<template>
  <Section :title="skills.title">
    <div class="skills-container">
      <div v-for="(category, i) in skills.skills" :key="i" class="skill-column">
        <h3>{{ category.category }}</h3>
        <ul>
          <li v-for="(item, j) in category.items" :key="j">
            {{ item.skill }}
          </li>
        </ul>
      </div>
    </div>
  </Section>
</template>

<script>
import Section from "./Section";

export default {
  name: "Skills",
  components: { Section },
  props: {
    skills: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.skills-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5mm;
}

.skill-column h3 {
  font-size: 9pt;
  font-weight: 700;
  margin-bottom: 3mm;
  letter-spacing: 0.5px;
}

.skill-column ul {
  list-style: none;
  font-size: 8pt;
  line-height: 1.6;
  padding: 0;
}

.skill-column li {
  margin-bottom: 1mm;
}

@media screen and (max-width: 202mm) {
  .skills-container {
    grid-template-columns: 1fr;
    gap: 3mm;
  }
}
</style>
